import { render } from "./InputQuestion.vue?vue&type=template&id=6f5aac69"
import script from "./InputQuestion.vue?vue&type=script&lang=ts"
export * from "./InputQuestion.vue?vue&type=script&lang=ts"
script.render = render

export default script